module.exports = __webpack_public_path__ + "img/cat-01-in.1a9b4646.svg";